export const UPLOAD_DOCUMENT_REQUEST = 'UPLOAD_DOCUMENT_REQUEST';

export const uploadDocumentRequest = ( formData ) => ({
    type: UPLOAD_DOCUMENT_REQUEST,
    payload: { formData }
});
